/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../../../logger';
import { Page } from '../../page';
import { Placement } from '../../placement';
import { AstPlacement } from './placement';

import type { AdCommunicatorEvents } from '../../../messaging';
import type { CampaignData } from '../../../types';
import type { PrebidAdUnit } from '../../../types/prebid';
import type { SiteConfig } from '../../config';

const logger = Logger.getInstance();

class AstPage extends Page {
  private static astInstance: AstPage;

  private constructor(siteConfig: SiteConfig) {
    super(siteConfig);
    logger.debug('AST Page instance created');
  }

  public static getInstance(siteConfig: SiteConfig): AstPage {
    if (!AstPage.astInstance) {
      AstPage.astInstance = new AstPage(siteConfig);
    }
    return AstPage.astInstance;
  }

  protected createPlacement(
    adUnit: PrebidAdUnit,
    adUnitTransformer: (adUnitCode: string) => string,
    campaignData: CampaignData[],
    siteConfig: SiteConfig
  ): Placement | undefined {
    return new AstPlacement(adUnit, adUnitTransformer, campaignData, siteConfig);
  }

  protected placementAdInteractionHandler(event: {
    data: AdCommunicatorEvents['AdInteraction'];
  }): void {
    logger.debug('AST Page received Ad Interaction event from AdCommunicator');
    const placement: AstPlacement = this.locateContainingPlacement(event) as AstPlacement;
    if (!placement) {
      logger.error('Ad interaction event received, but no containing placement found');
      return;
    }
    placement.dispatchAdInteraction();
  }
}

export { AstPage };
